.formFieldGroup {
    display: flex;
    margin: 0px;
}

.formFieldContainer {
    flex: 1;
    margin: 0px 10px 10px 10px;
}

.formFieldContainerBottom {
    flex: 1;
    margin: 0px 10px 30px 10px;
}

.trashIconContainer {
    align-self: flex-end;
    margin-bottom: 8px;
}

.deleteButton {
    margin-right: auto;
}
